import { withStyles } from '@material-ui/core';
import React from 'react';

import { Typography } from './Typography';

const StyledOfferHeader = withStyles(({ palette: { text } }) => ({
  root: {
    color: text.primary,
    display: 'inline-block',
    fontWeight: 'bold',
    margin: '20px 0 10px',
    padding: '0 5px',
    position: 'relative',
    textTransform: 'uppercase',
    zIndex: 0,

    '&:first-child': {
      marginTop: 0,
    },
  },
}))(Typography);

export const OfferHeader: React.FC<{
  fontSize?: number | string;
  evenUnderline?: boolean;
  children?: React.ReactNode;
}> = ({ children, evenUnderline, fontSize = '0.875rem' }) => (
  <StyledOfferHeader
    style={{
      fontSize: fontSize,
      ...(evenUnderline ? { overflow: 'hidden' } : {}),
    }}
  >
    {children}
  </StyledOfferHeader>
);
